const firebaseConfig = {
    apiKey: "AIzaSyAV1cCiLum1iMXTCg8tMZ5gg59gBEJ8oKc",
    authDomain: "react-jerin-parlour.firebaseapp.com",
    projectId: "react-jerin-parlour",
    storageBucket: "react-jerin-parlour.appspot.com",
    messagingSenderId: "555677719199",
    appId: "1:555677719199:web:8915071fac2f0af5eae0aa"
};
export default firebaseConfig;